<div class="relative">
  <button type="button" (click)="toggleEmojiPicker()">
    <lib-emoji-icon iconClass="size-4" stroke="var(--color-neutral-500)" />
  </button>

  @if (isPickerListOpen()) {
    <ng-container [ngTemplateOutlet]="pickerList" />
  }
</div>

<ng-template #pickerList>
  <div
    class="min-w-[17.5rem] min-h-[8rem] flex flex-col absolute bg-white shadow-xl rounded-lg items-center gap-lg py-2xl px-lg bottom-[2.5rem]"
    libClickOutSide
    (clickOutside)="isPickerListOpen.set(false)">
    <!---------- list header --------->
    <div
      class="flex items-center justify-between w-full border-b border-neutral-200 pb-md">
      <p class="text-neutral-900 text-base font-bold">
        {{ 'discussion_section_emoji_picker_title' | transloco }}
      </p>

      <button type="button" (click)="isPickerListOpen.set(false)">
        <lib-close-icon iconClass="size-6" stroke="var(--color-neutral-900)" />
      </button>
    </div>

    <!------------ emoji List ----------->
    <div class="flex flex-col gap-lg w-full">
      @for (list of emojiList(); track $index) {
        <div class="flex flex-col gap-sm">
          <div class="flex gap-x-sm gap-y-md flex-wrap">
            @for (emoji of list.emoji; track $index) {
              <ngx-emoji
                (emojiClick)="addEmoji($event)"
                [emoji]="emoji"
                [set]="'apple'"
                class="cursor-pointer"
                [size]="emojiSizeInPixels()" />
            }
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
